<template>
  <div>
    <container :active_path="'/invest/prosperity'" :plate="'投资军团'">
      <div class="base-warp">
        <div class="head">
          <el-row>
            <el-col :span="20">
              <el-form ref="form" label-width="80px" :inline="true" size="mini">
                <el-form-item>
                  <el-button type="success" @click="showDialog" icon="el-icon-plus">添加喜报</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="4">
              <el-button-group class="float-right">
                <el-button type="danger" size="mini" icon='el-icon-delete'>删除</el-button>
              </el-button-group>
            </el-col>
          </el-row>
        </div>
        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="日期" prop="addDate" align="center"></el-table-column>
            <el-table-column label="图片">
              <template slot-scope="s">
                <el-image style="width: 200px; height: 100px; " :src="s.row.prosperity" alt=""></el-image>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="s">
                <el-button-group>
                  <el-button type="danger" size="mini" icon='el-icon-delete' @click="deleter(s.row)"></el-button>

                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next"
          :page-size="pagesize" :total="total" background>
        </el-pagination>
      </div>
      <!-- dialog -->
      <el-dialog title="上传图片" :visible.sync="dialogVisible" width="30%" center>
        <el-form>

          <el-form-item label="喜报图片" :label-width="formLabelWidth">
            <div>
              <el-upload class="avatar-uploader" action="/api/Upload/uploadFile/" :show-file-list="false"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <img src="aaa" alt="">
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>
    </container>

  </div>
</template>

<script>
import Container from '../../../components/container.vue'

export default {
  components: {
    Container,
  },
  name: "Prosperity",
  data () {
    return {
      form: "",
      dialogVisible: false,
      formLabelWidth: "100px",
      imgPath: "",
      imageUrl: '',
      tabledata: [],
      pageNo: 1,
      pagesize: 14,
      total: 0,
    }
  },
  mounted () {
    this.gettabledata()
  },
  methods: {
    showDialog () {
      this.dialogVisible = true
      this.imageUrl = ''
    },
    confirm () {
      var params = {
        prosperity: this.imgPath
      }
      this.$api.addTheProsperity(params).then(
        data => {
          if (data == '添加成功') {
            this.$message.success("添加成功")
            this.dialogVisible = false;
            this.gettabledata()
          } else {
            this.$message.success(data)
          }
        }
      )
    },

    deleter (item) {
      this.$confirm('是否确定将' + item.name + '转移到房型管理草稿箱?')
        .then(_ => {
          var params = {
            id: item._id["$oid"]
          }
          this.$api.deleteTheProsperity(params).then(res => {
            if (res == '删除成功') {
              this.$message.success("删除成功")
              this.gettabledata()
            } else {
              this.$message.success(res)
            }
          })
        })
        .catch(_ => { })
    },
    handleAvatarSuccess (res, file) {
      if (res) {
        this.imgPath = res.data
      } else {
        this.$message.error('错误')
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isPNG) {
        this.$message.error('只能上传图片，不能上传其他文件!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPNG) && isLt2M;
    },
    gettabledata () {
      this.$api.selectTheProsperity().then(res => {
        this.tabledata = res
      })
    },
    currentChange (page) {
      this.pageNo = page;
      this.gettabledata();
    },
  }
}
</script>

<style scoped>
.avatar {
  width: 200px;
  height: 200px;
}
</style>